import { z } from "zod";

/**
 * A string that represents a hashed ID.
 * The hashed ID must satisfy the following criteria:
 * - Consists of exactly 4 characters.
 * - Each character can be a lowercase letter (a-z), an uppercase letter (A-Z), or a digit (0-9).
 * @example "a1B2"
 */
export const HashedIdSchema = z.string().regex(/^[a-zA-Z0-9]{4}$/);

/**
 * Schema for the comment details.
 */
export const ETagSchema = z.string().regex(/^"[a-f0-9]{32}"$/i);